import { Box, Button, Card, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { ANSWER_OPTIONS, BLANK_ANSWER } from './constants';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
  },
  cardAnswered: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  numberBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: theme.palette.action.selected,
    fontSize: '0.75rem',
    fontWeight: 'bold',
    flexShrink: 0,
  },
  text: {
    fontWeight: 500,
  },
  optionsRow: {
    display: 'flex',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  optionButton: {
    width: 44,
    height: 44,
    minWidth: 44,
    borderRadius: '50%',
    fontWeight: 'bold',
    padding: 0,
  },
  blankButton: {
    height: 44,
    borderRadius: 22,
    fontWeight: 'bold',
    textTransform: 'none',
  },
  optionButtonSelected: {
    boxShadow: theme.shadows[2],
  },
}));

export function QuestionCard({ question, selectedOptionId, onSelect }) {
  const classes = useStyles();
  const isBlankSelected = selectedOptionId === BLANK_ANSWER;

  return (
    <Card className={clsx(classes.card, selectedOptionId && classes.cardAnswered)}>
      <Box className={classes.header}>
        <Box className={classes.numberBadge}>{question.questionNumber}</Box>
        <Typography variant="body2" className={classes.text}>
          {question.shortQuestion}
        </Typography>
      </Box>
      <Box className={classes.optionsRow}>
        {ANSWER_OPTIONS.map((letter, idx) => {
          const opt = (question.options || [])[idx];
          const isSelected = !!opt && selectedOptionId === opt.id;
          return (
            <Button
              key={letter}
              variant={isSelected ? 'contained' : 'outlined'}
              color={isSelected ? 'primary' : 'default'}
              className={clsx(classes.optionButton, isSelected && classes.optionButtonSelected)}
              disabled={!opt}
              onClick={() => opt && onSelect(question.questionId, opt.id)}
            >
              {letter}
            </Button>
          );
        })}
        <Button
          variant={isBlankSelected ? 'contained' : 'outlined'}
          color={isBlankSelected ? 'primary' : 'default'}
          className={clsx(classes.blankButton, isBlankSelected && classes.optionButtonSelected)}
          onClick={() => onSelect(question.questionId, BLANK_ANSWER)}
        >
          Em Branco
        </Button>
      </Box>
    </Card>
  );
}
